import { ProgramCurrency } from '@models/membership/ProgramCurrency'
import { SBAPI } from '@supplement-bacon/react-toolkit/utils'
import { TableParams } from '@supplement-bacon/sb-table-filters'
import {
  MEMBERSHIP_PROGRAMS_URL,
  MEMBERSHIP_PROGRAM_CURRENCIES_URL,
} from '@utils/urls'
import { AxiosError } from 'axios'

const fetchProgramCurrencies = (params: TableParams) =>
  SBAPI.FetchPaginated<ProgramCurrency[]>(
    MEMBERSHIP_PROGRAM_CURRENCIES_URL,
    params
  )

const createProgramCurrency = (currency: ProgramCurrency) =>
  SBAPI.Post(`${MEMBERSHIP_PROGRAM_CURRENCIES_URL}`, currency).catch(
    (error: AxiosError) => {
      throw new Error(error.message)
    }
  )

const batchUpdateProgramCurrencies = (
  programSlug: string,
  items: { id: number; amount: number }[]
) =>
  SBAPI.Put(
    `${MEMBERSHIP_PROGRAMS_URL}/${programSlug}/currencies/batch-update`,
    { items }
  )

const deleteProgramCurrency = (currency: ProgramCurrency) =>
  SBAPI.Delete(`${MEMBERSHIP_PROGRAM_CURRENCIES_URL}/${currency.id}`)

export {
  batchUpdateProgramCurrencies,
  createProgramCurrency,
  deleteProgramCurrency,
  fetchProgramCurrencies,
}
